import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { createRouter, createWebHistory } from 'vue-router'
import ArticleDetail from './components/ArticleDetail.vue'
import AuthorDetail from './components/AuthorDetail.vue'
import UserDetail from './components/UserDetail.vue'
import UserEdit from './components/UserEdit.vue'
import SearchResult from './components/SearchResult.vue'
import MoreArticle from './components/MoreArticle.vue'
import MoreBook from './components/MoreBook.vue'
import UserDetailPost from './components/UserDetailPost.vue'
import UserDetailPermission from './components/UserDetailPermission.vue'
import UserDetailPaper from './components/UserDetailPaper.vue'
import UserDetailArticle from './components/UserDetailArticle.vue'
import UserDetailCollection from './components/UserDetailCollection.vue'
import BookDetail from './components/BookDetail.vue'
import TabIndex from './components/TabIndex.vue'
import PostIndex from './components/PostIndex.vue'
import NewsIndex from './components/NewsIndex.vue'
import AboutDetail from './components/AboutDetail.vue'

import NotFound from './components/NotFound.vue'

// 创建应用实例
const app = createApp(App)

// false阻止生产提示
app.config.productionTip = false
// 取消 Vue 所有的日志与警告。
app.config.silent = true
// 生产版本为false
app.config.devtools = false

// 计算文章发布至今的时间间隔
// app.filter('timeInteval', function(t){
//   if(typeof t === 'undefined') {
//     return '发布时间不详'
//   }
//   let d = new Date(t);
//   let nowd = new Date();
//   var mills = (nowd - d) / 1000;
//   if(Math.floor((mills / 60)) <= 1) {
//     return "刚刚发布";
//   }
//   if((mills / 60) < 60) {
//       return "发布于 " + Math.floor((mills / 60)) + " 分钟前";
//   } else if((mills / 60 / 60) < 24) {
//       return "发布于 " + Math.floor((mills / 60 / 60)) + " 小时前";
//   } else if((mills / 60 / 60 / 24) < 30) {
//       return "发布于 " + Math.floor((mills / 60 / 60 / 24)) + " 天前";
//   } else if((mills / 60 / 60 / 24 / 30) < 12) {
//       return "发布于 " + Math.floor((mills / 60 / 60 / 24 / 30)) + " 月前";
//   } else {
//       return "发布于 " + Math.floor((mills / 60 / 60 / 24 / 30 / 12)) + " 年前";
//   }
// })

app.config.globalProperties.$filters = {
  formatDate(date) {
    if(typeof date === 'undefined') {
      return '发布时间不详'
    }
    let d = new Date(date);
    let nowd = new Date();
    var mills = (nowd - d) / 1000;
    if(Math.floor((mills / 60)) <= 1) {
      return "刚刚发布";
    }
    if((mills / 60) < 60) {
        return "发布于 " + Math.floor((mills / 60)) + " 分钟前";
    } else if((mills / 60 / 60) < 24) {
        return "发布于 " + Math.floor((mills / 60 / 60)) + " 小时前";
    } else if((mills / 60 / 60 / 24) < 30) {
        return "发布于 " + Math.floor((mills / 60 / 60 / 24)) + " 天前";
    } else if((mills / 60 / 60 / 24 / 30) < 12) {
        return "发布于 " + Math.floor((mills / 60 / 60 / 24 / 30)) + " 月前";
    } else {
        return "发布于 " + Math.floor((mills / 60 / 60 / 24 / 30 / 12)) + " 年前";
    }
  }
}

// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }



const routes = [
  {path:'/articleDetail/:article_id', component:ArticleDetail},
  {path:'/authorDetail/:user_id', component:AuthorDetail},
  {
    path:'/userDetail/:user_id', 
    component:UserDetail,
    children: [
      {
        path: 'userDetailPost',
        component: UserDetailPost
      },
      {
        path: 'userDetailPaper',
        component: UserDetailPaper
      },
      {
        path: 'userDetailPermission',
        component: UserDetailPermission
      },
      {
        path: 'userDetailArticle',
        component: UserDetailArticle
      },
      {
        path: 'userDetailCollection',
        component: UserDetailCollection
      }
    ]
  },
  {path:'/userEdit/:user_id', component:UserEdit},
  {path:'/search/:search_text', name:'search', component:SearchResult},
  {path:'/more_article', component:MoreArticle},
  {path:'/more_book', component:MoreBook},
  {path:'/book_detail/:book_id', component:BookDetail},
  {path:'/about_detail/:book_id', component:AboutDetail},
  {path:'/postIndex/:post_id', component:PostIndex},
  {path:'/newsIndex/:category_id', component:NewsIndex},
  {path:'/', component:TabIndex},
  {path:'/:pathMatch(.*)*', component: NotFound}
]

// const router = new VueRouter({
//   mode:'hash',
//   routes,
//   scrollBehavior (to, from, savedPosition) {
//     return { x: 0, y: 0 }
//   }
// });

const router = createRouter({
  history: createWebHistory(),
  routes
});

app.use(router)
app.use(ElementPlus)

app.mount('#app')
